import _ from "lodash";
import React from "react";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { StandardTableSortablePropertyHeader } from "../../components/tables/StandardTable";
import useCashBalances from "./hooks/useCashBalances";
import CustodianCashBalanceManagementTableRow from "./components/CustodianCashBalanceManagementTableRow";

const CustodianCashBalanceManagement = () => {
    const {
        clear: refreshTable,
        loadMore,
        isRowLoaded,
        sort,
        sortTable,
        results,
        totalCount,
        error,
        isNextPageLoading,
        isError,
    } = useCashBalances();

    return (

        <React.Fragment>
            <VirtualTable
                enableScrollTracking={true}
                row={CustodianCashBalanceManagementTableRow}
                header={
                    <thead>
                        <tr>
                            <StandardTableSortablePropertyHeader
                                property="masterAccountName"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Client
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="adviser"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Adviser
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="designation"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Designation
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="platformAccountId"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Account
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="cashBalance"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Balance
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="latestBalanceDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Date
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="days"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Duration
                            </StandardTableSortablePropertyHeader>
                        </tr>
                    </thead>
                }
                footer={
                    <TableRecordCountDisplayFooter 
                        totalCount={totalCount}
                        isNewRecordsDisplayed={false}
                        newRecordsSinceCache={0}
                        reload={refreshTable}
                    />
                }
                error={error}
                isItemLoaded={isRowLoaded}
                loadMoreItems={loadMore}
                itemSize={42}
                isLoading={isNextPageLoading}
                itemCount={totalCount}
                itemData={results}
            />
        </React.Fragment>
    );
};

export default CustodianCashBalanceManagement;
